import { SearchService } from "../../_service/search.service";

export const SET_SEARCH_REQUEST_LOADING = "SET_SEARCH_REQUEST_LOADING";
export const SEARCH_REQUEST_SUCCESS = "SEARCH_REQUEST_SUCCESS";
export const SEARCH_APPEND_SUCCESS = "SEARCH_APPEND_SUCCESS";
export const SEARCH_SET_ACTIVE_TYPE = "SEARCH_SET_ACTIVE_TYPE";

export function setSearchLoadingAction() {
  return {
    type: SET_SEARCH_REQUEST_LOADING,
    isLoading: true,
  };
}

export function setSearchRequestSuccess(payload) {
  return {
    type: SEARCH_REQUEST_SUCCESS,
    payload,
  };
}

export function appendSearchRequestSuccess(payload, meta) {
  return {
    type: SEARCH_APPEND_SUCCESS,
    payload,
    meta,
  };
}

export function setActiveSearchType(searchType) {
  return {
    type: SEARCH_SET_ACTIVE_TYPE,
    searchType,
  };
}

// thunk (page 1)
export function getSearchResults(search = "", searchType = "posts") {
  return (dispatch, getState) => {
    if (!search) {
      return dispatch(
        setSearchRequestSuccess({
          search: "",
          resultsByType: {},
          hasMoreByType: {},
          pageByType: {},
        })
      );
    }

    const { community } = getState();
    dispatch(setSearchLoadingAction(true));
    SearchService.search(community?.id, search, searchType, 1, 15).then(
      ({ data, hasMore }) => {
        dispatch(
          setSearchRequestSuccess({
            search,
            resultsByType: {
              [searchType]: data?.[searchType] || [],
            },
            hasMoreByType: {
              [searchType]: Boolean(hasMore),
            },
            pageByType: {
              [searchType]: 1,
            },
          })
        );
      }
    );
  };
}

// thunk (load more)
export function loadMoreSearchResults(search = "", searchType = "posts") {
  return (dispatch, getState) => {
    if (!search) return;
    const { community, search: searchState } = getState();
    const currentPage = searchState?.pageByType?.[searchType] || 1;
    const nextPage = currentPage + 1;
    dispatch(setSearchLoadingAction(true));
    SearchService.search(community?.id, search, searchType, nextPage, 15).then(
      ({ data, hasMore }) => {
        dispatch(
          appendSearchRequestSuccess(
            {
              search,
              resultsByType: {
                [searchType]: data?.[searchType] || [],
              },
              hasMoreByType: {
                [searchType]: Boolean(hasMore),
              },
              pageByType: {
                [searchType]: nextPage,
              },
            },
            { searchType }
          )
        );
      }
    );
  };
}

const INITIAL_STATE = {
  search: "",
  activeType: "posts",
  resultsByType: {},
  hasMoreByType: {},
  pageByType: {},
  isLoading: false,
};

export function searchReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SEARCH_REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        search: action?.payload?.search ?? state.search,
        resultsByType: {
          ...state.resultsByType,
          ...(action?.payload?.resultsByType || {}),
        },
        hasMoreByType: {
          ...state.hasMoreByType,
          ...(action?.payload?.hasMoreByType || {}),
        },
        pageByType: {
          ...state.pageByType,
          ...(action?.payload?.pageByType || {}),
        },
      };
    case SEARCH_APPEND_SUCCESS: {
      const t = action?.meta?.searchType;
      const incoming = action?.payload?.resultsByType?.[t] || [];
      return {
        ...state,
        isLoading: false,
        search: action?.payload?.search ?? state.search,
        resultsByType: {
          ...state.resultsByType,
          [t]: [...(state.resultsByType?.[t] || []), ...incoming],
        },
        hasMoreByType: {
          ...state.hasMoreByType,
          ...(action?.payload?.hasMoreByType || {}),
        },
        pageByType: {
          ...state.pageByType,
          ...(action?.payload?.pageByType || {}),
        },
      };
    }
    case SEARCH_SET_ACTIVE_TYPE:
      return {
        ...state,
        activeType: action.searchType,
      };
    default:
      return state;
  }
}
